import { Button, Card, Typography } from "antd"
import { CheckCircleOutlined } from '@ant-design/icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTrafficCone, faBan, faCalendarDay } from '@fortawesome/pro-solid-svg-icons'
import { ScheduledEvent, Visit, VisitWorkareaStatusRecord } from "../scheduleApi"
import { useState } from "react"
import ManageVisitStatuses from "./Modals/ManageVisitStatuses"
import { VisitWorkareaStatuses } from "../../../common/constants"

const { Text } = Typography

type Props = {
  event: ScheduledEvent | null
  visit: Visit
  workareaStatuses: VisitWorkareaStatusRecord[]
}

const JobDrawerVisitStatuses = ({ event, visit, workareaStatuses }: Props) => {
  const [isManageVisitStatusesOpen, setIsManageVisitStatusesOpen] = useState(false)

  const visitWorkareaIds = workareaStatuses
    .filter(ws => ws.visitId === visit.id)
    .map(ws => ws.workareaId)

  const workareas = [...new Set(visitWorkareaIds)]

  return <>
    <div style={{ marginBottom: '24px' }}>
      <div style={{ marginBottom: '24px' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '8px' }}>
          <Text style={{ fontSize: '14px' }}>
            Visit Statuses
          </Text>
          <span>
            <Button
              onClick={() => setIsManageVisitStatusesOpen(true)}
              disabled={!visit}>
              Manage
            </Button>
          </span>
        </div>
      </div>

      {visit ? (
        workareas.length > 0 ? (
          <Card size="small" style={{ display: 'flex', flexDirection: 'column' }}>
            {workareas.map((workareaId, index, arr) => {
              const visitWorkareaStatus = workareaStatuses.find(
                ws => ws.visitId === visit.id && ws.workareaId === workareaId
              )
              const eventWorkareaIdsList = event?.workAreaIds?.split(',').map(id => parseInt(id.trim())) ?? []
              const eventWorkareaNames = event?.workAreaNames?.split(',').map(name => name.trim()) ?? []
              const workareaIdIndex = eventWorkareaIdsList.indexOf(workareaId ?? -1)
              const workareaName = visitWorkareaStatus?.workareaName
                ?? (workareaIdIndex !== -1 ? eventWorkareaNames[workareaIdIndex] : null)
                ?? `Work Area ${workareaId}`

              return (
                <div
                  key={workareaId}
                  style={{
                    paddingBottom: index < arr.length - 1 ? '12px' : 0,
                    marginBottom: index < arr.length - 1 ? '12px' : 0,
                    borderBottom: index < arr.length - 1 ? '1px solid #e8e8e8' : 'none'
                  }}
                >
                  <div style={{
                    fontSize: '16px',
                    fontWeight: '500',
                    marginBottom: '8px',
                    color: '#333'
                  }}>
                    {workareaName}
                  </div>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                    {(() => {
                      const status = visitWorkareaStatus?.status
                      switch (status) {
                        case VisitWorkareaStatuses.InProgress:
                          return (
                            <>
                              <FontAwesomeIcon icon={faTrafficCone} style={{ color: '#fa8c16', fontSize: '14px' }} />
                              <span style={{ fontSize: '14px' }}>In Progress</span>
                            </>
                          )
                        case VisitWorkareaStatuses.Completed:
                          return (
                            <>
                              <CheckCircleOutlined style={{ color: '#52c41a', fontSize: '14px' }} />
                              <span style={{ fontSize: '14px' }}>Completed</span>
                            </>
                          )
                        case VisitWorkareaStatuses.CompletedUnbillable:
                          return (
                            <>
                              <CheckCircleOutlined style={{ color: '#52c41a', fontSize: '14px' }} />
                              <span style={{ fontSize: '14px' }}>Completed (Unbillable)</span>
                            </>
                          )
                        case VisitWorkareaStatuses.Skipped:
                          return (
                            <>
                              <FontAwesomeIcon icon={faBan} style={{ color: '#000', fontSize: '14px' }} />
                              <span style={{ fontSize: '14px' }}>Skipped</span>
                            </>
                          )
                        case VisitWorkareaStatuses.SkippedReschedule:
                          return (
                            <>
                              <FontAwesomeIcon icon={faCalendarDay} style={{ color: '#000', fontSize: '14px' }} />
                              <span style={{ fontSize: '14px' }}>Skipped (Reschedule)</span>
                            </>
                          )
                        default:
                          return (
                            <>
                            </>
                          )
                      }
                    })()}
                  </div>
                </div>
              )
            })}
          </Card>
        ) : (
          <div style={{
            border: '2px dashed #d9d9d9',
            borderRadius: '6px',
            padding: '40px 20px',
            textAlign: 'center',
            backgroundColor: 'transparent'
          }}>
            <Text style={{ color: '#8c8c8c', fontSize: '14px' }}>No Statuses</Text>
          </div>
        )
      ) : (
        <div style={{
          border: '2px dashed #d9d9d9',
          borderRadius: '6px',
          padding: '40px 20px',
          textAlign: 'center',
          backgroundColor: 'transparent'
        }}>
          <Text style={{ color: '#8c8c8c', fontSize: '14px' }}>No associated visit</Text>
        </div>
      )}
    </div>
    <ManageVisitStatuses
      open={isManageVisitStatusesOpen}
      onClose={() => setIsManageVisitStatusesOpen(false)}
      event={event}
      visit={visit}
      workareaStatuses={workareaStatuses.filter(ws => ws.visitId === visit?.id)}
    />
  </>
}

export default JobDrawerVisitStatuses